import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import messages from '../../../../../intl/messages';
import { LabeledColumn } from '../../../../lab/TextGroup/LabeledColumn';

interface OwnProps {
  duration: string;
}

interface DurationColumnProps extends OwnProps, InjectedIntlProps {}

const DurationColumnBase: FunctionComponent<DurationColumnProps> = ({
  duration,
  intl: { formatMessage },
}) => {
  return (
    <LabeledColumn
      label={formatMessage(messages.segmentContent.duration)}
      mainText={duration}
    />
  );
};

DurationColumnBase.displayName = 'DurationColumn';

const enhance = compose<DurationColumnProps, OwnProps>(
  pure,
  injectIntl,
);

export const DurationColumn = enhance(DurationColumnBase);

DurationColumn.displayName = 'DurationColumn';
